import React from "react";
import useOffers from "../../../features/adminDashboard/offers/useOffers";
import SimpleCarousel from "../../../features/adminDashboard/offers/components/SimpleCarousel";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import Dashboard from "../Dashboard";

function UserOffers() {
  const {
    offersError,
    activeOffers: offers,
    isGettingActiveOffers,
  } = useOffers();

  const content = () => {
    if (isGettingActiveOffers) {
      return (
        <div className="flex justify-center items-center h-[500px]">
          <CustomLoading />
        </div>
      );
    }

    if (offersError) {
      return (
        <div className="text-center text-red-600 py-8">
          Error loading offers. Please try again later.
        </div>
      );
    }

    if (!offers?.length) {
      return (
        <div className="text-center py-8">
          No active offers available at the moment.
        </div>
      );
    }

    return (
      <div className="w-full">
        <SimpleCarousel offers={offers} />
      </div>
    );
  };

  return <Dashboard>{content()}</Dashboard>;
}

export default UserOffers;
